import { apiSlice } from "../../../app/api/apiSlice";

export const paMilestoneCountSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getPaMilestoneCount: builder.mutation({
			query: () => ({
				url: "/api/v1/admin/internal_users_filtered_milestone/PA/",
				method: "GET",
			}),
		}),
	}),
});

export const { useGetPaMilestoneCountMutation } = paMilestoneCountSlice;
